import { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Heading,
  HStack,
} from "@chakra-ui/react";
import CodesetSelect from "./CodesetSelect";
import { HiOutlinePlus, HiOutlineTrash } from "react-icons/hi";

const TextEditor = ({
  text = [],
  onChange,
  size = "md",
}) => {
  const [localText, setLocalText] = useState(text);

  useEffect(() => {
    setLocalText(text);
  }, [text]);

  const handleChange = (index, field, value) => {
    const updated = [...localText];
    updated[index][field] = value;
    setLocalText(updated);
    onChange(updated);
  };

  const handleAdd = () => {
    const newEntry = {
      type: "",
      agencyCode: "",
      agencyCodeSetCode: "",
      reference: "",
      name: "",
      value: "",
    };
    const updated = [...localText, newEntry];
    setLocalText(updated);
    onChange(updated);
  };

  const handleDelete = (index) => {
    const updated = [...localText];
    updated.splice(index, 1);
    setLocalText(updated);
    onChange(updated);
  };

  return (
    <Box borderWidth="1px" borderRadius="md" p={4} borderColor="gray.500">
      <HStack mb={3} justifyContent="flex-start">
        <Heading size={size}>Text</Heading>
        <IconButton icon={<HiOutlinePlus />} size={size} onClick={handleAdd} />
      </HStack>

      <Table variant="simple" size={size}>
        <Thead>
          <Tr>
            <Th fontSize={size}>Type</Th>
            <Th fontSize={size}>Agency</Th>
            <Th fontSize={size}>Code Set</Th>
            <Th fontSize={size}>Reference</Th>
            <Th fontSize={size}>Name</Th>
            <Th fontSize={size}>Value</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {localText.map((textItem, idx) => (
            <Tr key={idx}>
              <Td>
                <CodesetSelect
                  codesetCode="T02"
                  value={textItem.type ? { code: textItem.type, description: "" } : null}
                  onChange={(val) => handleChange(idx, "type", val.code)}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <CodesetSelect
                  codesetCode="3055"
                  value={textItem.agencyCode ? { code: textItem.agencyCode, description: "" } : null}
                  onChange={(val) => handleChange(idx, "agencyCode", val.code)}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <CodesetSelect
                  codesetCode="C01"
                  value={textItem.agencyCodeSetCode ? { code: textItem.agencyCodeSetCode, description: "" } : null}
                  onChange={(val) => handleChange(idx, "agencyCodeSetCode", val.code)}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <Input
                  size={size}
                  height="32px"
                  value={textItem.reference || ""}
                  onChange={(e) => handleChange(idx, "reference", e.target.value)}
                />
              </Td>
              <Td>
                <Input
                  size={size}
                  height="32px"
                  value={textItem.name || ""}
                  onChange={(e) => handleChange(idx, "name", e.target.value)}
                />
              </Td>
              <Td>
                <Input
                  size={size}
                  height="32px"
                  value={textItem.value || ""}
                  onChange={(e) => handleChange(idx, "value", e.target.value)}
                />
              </Td>
              <Td>
                <IconButton
                  icon={<HiOutlineTrash />}
                  size={size}
                  onClick={() => handleDelete(idx)}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default TextEditor;
